import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.absence.loading;
export const absenceErrorMessage = (state: RootState) => state.absence.error;
export const absenceDataResponse = (state: RootState) =>
  state.absence.absenceResponse;
